<template>
	<div class="anchor">
		<header>
			<h1>
				<router-link to="/">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">主播详情</p>
			</h1>
		</header>
		<div class="anchorx" v-for="item in zbxq">
			<!-- 主播 -->
			<div class="anchorxx">
				<img :src="'http://ts.winwulian.com/uploads/anchorphoto'+'/'+item.anc_pic" class="anchorxx_img">
				<div class="anchorxx_pp">
					<p class="anchorxx_ppvip">{{item.anc_name}}</p>
					<p class="anchorxx_ppvipp">
						{{item.anc_brief}}
					</p>	
				</div>
			</div>
			<!-- 书 -->
			<div class="anchorshu">
				<!-- 1 -->
				<div class="anchorshuxx"  v-for="item in zbzj">
					<router-link :to="'/discover/discont/'+item.book_id">
					<img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="anchorshuxx_img">
					<div class="anchorshuxx_pp">
						<p class="anchorshuxx_pgs">{{item.b_bookname}}</p>
						<p class="shuxx_pgs shuc_pcs" v-if="item.b_author != '' && item.b_author != null">作者:<span>{{item.b_author}}</span></p>

						<p class="shuxx_pgs shuc_pcs" v-if="item.b_readuser != '' && item.b_readuser != null">朗读:<span>{{item.b_readuser}}</span></p>

						<p class="shuxx_pgs shuc_pcs" v-if="item.b_type != '' && item.b_type != null">体载:<span>{{item.b_type}}</span></p>

						<p class="shuxx_pgs shuc_pcs" v-if="item.b_people != '' && item.b_people != null">适合人群:<span>{{item.b_people}}</span></p>
						<p class="shuc_pcs">
							<span class="qmxx">{{item.money}}</span>
							<span class="shuxx_pgs">{{item.b_price}}</span>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<v-icon name="volume-up" class="dis_bell"></v-icon>&nbsp;
							<span class="shuxx_pgs">{{item.b_playnum}}</span>
						</p>
					</div>
					</router-link>
				</div>
				
				<!-- ... -->
			</div>
			<!-- 书ed -->
			<!-- 没有更多了 -->
			<p class="anr_myl">没有更多了...</p>
		</div>
	</div>
</template>
<script type="text/javascript">
	import { CURL } from "../../lib/url.js";
	export default {
      data(){
          return {
              params: '',
              zbxq:[],
              zbzj:[]
          }
      },
       mounted(){
	    this.getAjax();
	  
	  },
      created(){
		  var param = this.$route.params.id;
		 
		  // console.log(param)
          this.params = param
      },
       methods:{
            getAjax:function () {
             var successCallback =  (response) => {
                console.log('服务器请求成功了')
                
                if(response){
                  this.zbzj = response.anchor
                  for(var i=0;i<this.zbzj.length;i++){
                  	if(this.zbzj[i].b_price == '0' || this.zbzj[i].b_price == '0.00'){
                  		this.zbzj[i]['b_price'] = '免费'
                  	}else{
                  		this.zbzj[i]['money'] = '￥'
                  	}
                  }
                  
                  this.zbxq = response.man
                }
              }
              var errorCallback =  (response) => {
                  console.log('服务器请求出错了')
              }
               this.$http.get(CURL+'/portal/All/getzbxq?id='+this.$route.params.id,{
              	data:{}
              }).then(successCallback,errorCallback);
            }
          }
  }
</script>
<style lang="scss" scoped>
/**/
.anr_myl{
	padding: 10px 0 10px 0;
	background-color: #eee;
	text-align: center;
	float: left;
	width: 36%;
	margin: 20px 32% 30px 32%;
}
/*书*/
.shuc_pcs{
	margin-top: 3px;
}
.shuxx_pgs{
	color: #555;
}
.anchorshuxx_pgs{
	margin-top: 5px;
	font-weight: 550;
	font-size: 16px;
	color: #333;
}
.qmxx{
	color: #00a8d9;
}
.dis_bell{
	width: 10px;
	padding-top: 5px;
	color: #00a8d9;
}
.anchorshuxx_pp{
	float: left;
	width: 68%;
}
.anchorshuxx_img{
	float: left;
	width: 25%;
	margin-left: 2.5%;
	margin-right: 2.5%;
}
.anchorshuxx{
	float: left;
	width: 100%;
	border-bottom: #eee solid 2px;
	padding-bottom: 15px;
}
.anchorshu{
	float: left;
	width: 100%;
	margin-top: 30px;	
}
/*cnt*/
.anchorxx_ppvipp{
	margin-top: 10px;
	line-height: 20px;
	color: #555;
	font-size: 13px;
}
.anchorxx_ppvip{
	font-size: 18px;
	font-weight: 500;
}
.anchorxx_pp{
	float: left;
	width: 55%;
	padding: 8px 12px 0 0;
}
.anchorxx_img{
	float: left;
	width: 40%;
	margin-left: 2.5%;
	margin-right: 2.5%;
}
.anchorxx{
	float: left;
	width: 100%;
	margin-top: 10px;
}
.anchorx{
	float: left;
	margin-top: .7rem;
	width: 100%;
}
/*head*/
header{
	position: fixed;
  	height: .4rem;
 	background:url(../../img/ss.png);
    background-size:100% 100%;
    background-repeat: no-repeat;
 	float: left;
 	width: 100%;
 	h1{
   		margin-top: .2rem;
  	}
}
.set_1{
	text-align: center;
    float: left;
    width: 80%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height: 0;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top:-7px;
	width: 5%;
	color: #FFFFFF;
}
/*xxxx*/
.anchor{
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/shouye/anchor.vue